import {
  LayoutDashboard, Map, Activity, FolderSearch, Crown, ConciergeBell, Gavel, Video, MonitorPlay, Briefcase,
  Landmark, Wallet, Vault, Building, BookOpen, ScrollText, FileBarChart, Scale, CreditCard, Percent, HandCoins,
  Receipt, Trophy, ShieldCheck, Fingerprint, FileSignature, ClipboardList, Package, ShieldAlert, PenTool, Award,
  Heart, Library, FilePen, Users, UserCheck, Inbox, RotateCcw, BarChart3, Gem, Building2, Boxes, TrendingUp,
  ShoppingCart, MessageSquareQuote, Radio, FileQuestion, ListChecks, Lock, MessageCircle, Bell, Mail, Palette,
  LayoutTemplate, Monitor, SlidersHorizontal, Settings2, Database, Plug, Command, FileText, Send, BookMarked, KeyRound, Zap, Stamp,
} from "lucide-react";

// Every admin section, grouped into eight departments. `route` items navigate to a
// standalone page; everything else switches the `?tab=` panel on /admin.
export const ADMIN_CLUSTERS = [
  {
    key: "operations", label: "Operations", icon: Activity,
    items: [
      { key: "overview", label: "Dashboard", icon: LayoutDashboard },
      { key: "operations", label: "Operations Map", icon: Map },
      { key: "live-pulse", label: "Live Pulse", icon: Activity },
      { key: "srn-ledger", label: "SRN Ledger", icon: FolderSearch },
      { key: "director-suite", label: "Director Suite", icon: Crown, badge: "director" },
      { key: "founder-concierge", label: "Founder Concierge", icon: ConciergeBell },
      { key: "board-motions", label: "Board Motions", icon: Gavel },
      { key: "meetings", label: "Meetings", icon: Video },
      { key: "virtual-meetings", label: "Virtual Meetings", icon: MonitorPlay },
      { key: "careers", label: "Careers", icon: Briefcase },
    ],
  },
  {
    key: "pioneers", label: "The Pioneers", icon: Crown,
    items: [
      { key: "pioneers", label: "The Pioneers", icon: Crown },
      { key: "pioneer-access-control", label: "Pioneer Access Control", icon: KeyRound },
    ],
  },
  {
    key: "finance", label: "Finance & Banking", icon: Landmark,
    items: [
      { key: "vcb", label: "Vinci Core Banking", icon: Landmark, tag: "PREMIUM" },
      { key: "property-desk", label: "Vinci Property Desk", icon: Gem, tag: "NEW" },
      { key: "payment-rails", label: "Payment Rails · PhonePe", icon: Zap },
      { key: "wallet", label: "Wallet Console", icon: Wallet },
      { key: "payouts", label: "Vendor Payouts", icon: Send },
      { key: "treasury-desk", label: "Treasury Desk", icon: Vault },
      { key: "banking-onboarding", label: "Banking Onboarding", icon: Building },
      { key: "ledger", label: "Master Ledger", icon: BookOpen },
      { key: "sovereign-ledger", label: "Sovereign Ledger", icon: ScrollText },
      { key: "banker-report", label: "Banker Report", icon: FileBarChart },
      { key: "settlement-desk", label: "Settlement Desk", icon: Scale },
      { key: "credit-limits", label: "Credit Limits", icon: CreditCard },
      { key: "commission-desk", label: "Commission Desk", icon: Percent },
      { key: "claims", label: "Claims", icon: HandCoins },
      { key: "indirect-claims", label: "Indirect Claims", icon: Receipt },
      { key: "invoice-hub", label: "Invoicing Hub", icon: FileText },
      { key: "gst-desk", label: "GST Billing Desk", icon: Receipt },
      { key: "billdesk", label: "Vinci BillDesk", icon: Receipt, tag: "NEW" },
      { key: "rewards", label: "Rewards", icon: Trophy },
      { key: "deal-protection", label: "Deal Protection", icon: ShieldCheck },
    ],
  },
  {
    key: "compliance", label: "Compliance & Legal", icon: Scale,
    items: [
      { key: "vinci-manual", label: "Vinci Manual", icon: BookMarked },
      { key: "verifications", label: "KYC Verifications", icon: Fingerprint, badge: "kyc" },
      { key: "agreements", label: "Agreements", icon: FileSignature },
      { key: "compliance-log", label: "Compliance Log", icon: ClipboardList },
      { key: "compliance-capsule", label: "Compliance Capsule", icon: Package },
      { key: "refund-compliance", label: "Refund Compliance", icon: ShieldAlert },
      { key: "legal-desk", label: "Legal Desk", icon: Gavel },
      { key: "signatory-vault", label: "Signatory Vault", icon: PenTool },
      { key: "seal-desk", label: "Seal Preview Desk", icon: Stamp },
      { key: "certificates", label: "Certificates", icon: Award },
      { key: "legacy-goodwill", label: "Legacy & Goodwill", icon: Heart },
      { key: "bureaucratic-library", label: "Bureaucratic Library", icon: Library, route: "/admin/bureaucratic" },
      { key: "correction-pool", label: "Correction Pool", icon: FilePen, route: "/admin/corrections" },
    ],
  },
  {
    key: "users", label: "Users & Empanelment", icon: Users,
    items: [
      { key: "users", label: "Buyers & Sellers", icon: Users },
      { key: "approvals", label: "User Approvals", icon: UserCheck, badge: "approvals" },
      { key: "onboarding-inbox", label: "Onboarding Inbox", icon: Inbox },
      { key: "reinstatements", label: "Reinstatements", icon: RotateCcw },
      { key: "seller-ranking", label: "Seller Ranking", icon: BarChart3 },
      { key: "big-cap", label: "Big-Cap League", icon: Gem },
      { key: "entities", label: "Billing Entities", icon: Building2 },
    ],
  },
  {
    key: "catalog", label: "Products & Catalog", icon: Boxes,
    items: [
      { key: "products", label: "Products", icon: Boxes },
      { key: "rates", label: "Daily Rates", icon: TrendingUp },
    ],
  },
  {
    key: "rfq", label: "RFQ & Orders", icon: ShoppingCart,
    items: [
      { key: "orders", label: "Orders", icon: ShoppingCart },
      { key: "quote-requests", label: "Quote Requests", icon: MessageSquareQuote },
      { key: "rfq-broadcast", label: "RFQ Broadcast", icon: Radio },
      { key: "buyer-quotations", label: "Buyer Quotations", icon: FileQuestion },
      { key: "requirements", label: "Requirements", icon: ListChecks },
      { key: "quotations", label: "Quotations", icon: FileText },
      { key: "price-lock", label: "Price Lock Board", icon: Lock },
      { key: "inquiries", label: "Inquiries", icon: MessageCircle },
    ],
  },
  {
    key: "comms", label: "Communications", icon: Bell,
    items: [
      { key: "notifications", label: "Notifications", icon: Bell, badge: "notifs" },
      { key: "communications", label: "Communications", icon: Mail },
      { key: "brand-assets", label: "Brand Vault", icon: Palette },
      { key: "letterhead-studio", label: "Letterhead Studio", icon: LayoutTemplate },
      { key: "monumental-studio", label: "Monumental Studio", icon: Monitor },
    ],
  },
  {
    key: "settings", label: "Platform Settings", icon: Settings2,
    items: [
      { key: "financial-rules", label: "Financial Rules", icon: SlidersHorizontal },
      { key: "fee-management", label: "Fee Management", icon: Percent },
      { key: "data-governance", label: "Data Governance", icon: Database },
      { key: "zoho-books", label: "Zoho Books", icon: Plug },
      { key: "executive-command", label: "Executive Command", icon: Command, route: "/admin/command" },
    ],
  },
];

export const ADMIN_ITEMS = ADMIN_CLUSTERS.flatMap((c) => c.items.map((i) => ({ ...i, cluster: c.key })));
export const findClusterFor = (key) => ADMIN_ITEMS.find((i) => i.key === key)?.cluster;
export const itemForRoute = (pathname) => ADMIN_ITEMS.find((i) => i.route === pathname);
